/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for oral exam egress max-duration guard reconciliation.
 */
export interface OralExamEgressGuardReconcileParams {
  [key: string]: unknown;
}
